// 把"非首屏渲染必需"的工作推到首屏 paint 之后(主线程空闲时)。
// requestIdleCallback 优先;老 Safari(<16.4) 用 rAF + setTimeout 兜底,确保让位给首屏 paint。
type PaintHandle = { id: number; idle: boolean };

export function scheduleAfterPaint(
  fn: () => void,
  timeoutMs = 3000
): PaintHandle {
  const w = window as unknown as {
    requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number;
  };
  if (typeof w.requestIdleCallback === "function") {
    return {
      id: w.requestIdleCallback(fn, { timeout: timeoutMs }),
      idle: true,
    };
  }
  const id = window.setTimeout(() => requestAnimationFrame(fn), 200);
  return { id, idle: false };
}

export function cancelAfterPaint(h?: PaintHandle): void {
  if (!h) return;
  const w = window as unknown as { cancelIdleCallback?: (id: number) => void };
  if (h.idle && typeof w.cancelIdleCallback === "function") {
    w.cancelIdleCallback(h.id);
  } else {
    clearTimeout(h.id);
  }
}
